/* eslint-disable max-len */
import React, { FC, useContext } from 'react';
import { CreateEditEstimateNavEnum } from 'containers/estimates/constants';
import { CreateEstimateContextType } from 'containers/estimates/types';
import EstimateNotesSection from 'containers/estimates/create-edit-estimate/components/EstimateNotesSection';
import EstimateAttachmentsSection from 'containers/estimates/create-edit-estimate/components/EstimateAttachmentsSection';
import CreateEstimateTnC from './CreateEstimateTnC';
import { TNC } from 'containers/settings/settings.model';
import { selectEstimateTncEdited } from 'containers/estimates/estimatesSlice';
import { useAppSelector } from 'hooks';

interface EstimateNotesAndAttachmentsSectionProps {
  className?: string;
  context: React.Context<CreateEstimateContextType>;
  termsAndConditions: TNC | null;
  isLoadingTermsAndConditions: boolean;
}

const EstimateNotesAndAttachmentsSection: FC<EstimateNotesAndAttachmentsSectionProps> = ({
  context,
  termsAndConditions,
  isLoadingTermsAndConditions
}) => {
  const { selectedEstimateTab, setSelectedEstimateTab } = useContext<CreateEstimateContextType>(context);
  const estimateTncEdited = useAppSelector(selectEstimateTncEdited);

  const isTabSelected = selectedEstimateTab === CreateEditEstimateNavEnum.NOTES_ATTACHMENTS;

  const handleTabFocus = () => {
    setSelectedEstimateTab(CreateEditEstimateNavEnum.NOTES_ATTACHMENTS);
  };

  return (
    <div onFocus={handleTabFocus}>
      <h2 className={`mb-2 text-xl font-bold ${isTabSelected ? 'text-primaryBtn' : 'text-heading'}`}>
        Notes & Attachments
      </h2>
      <div
        className={`relative rounded-md border py-6 px-8 ${isTabSelected ? 'border-primaryBtn' : 'border-borderGray'}`}>
        <EstimateNotesSection handleOnFocus={handleTabFocus} />
        {!isLoadingTermsAndConditions && (termsAndConditions?.enabled || estimateTncEdited) && <CreateEstimateTnC />}
        <EstimateAttachmentsSection handleOnFocus={handleTabFocus} />
      </div>
    </div>
  );
};

export default EstimateNotesAndAttachmentsSection;
